import type { CityActivity, PlaceContent } from '@london-life/contracts';
import { geo } from '@london-life/game/city/layout';

export type { CityActivity };

// a place from the published content, as the map shows it: placed from its real coordinates
export function toCityActivity(place: PlaceContent): CityActivity {
  return {
    id: place.id,
    name: place.name,
    area: place.area,
    icon: place.icon,
    position: geo(place.lon, place.lat),
    description: place.description,
    things: place.things,
    ...(place.badge ? { badge: place.badge } : {}),
    ...(place.comingSoon ? { comingSoon: true } : {}),
    visible: place.visible,
    sortOrder: place.sortOrder,
  };
}
// every place on the map, in the admin's order
export const cityActivitiesOf = (places: PlaceContent[]) =>
  places.map(toCityActivity).sort((a, b) => a.sortOrder - b.sortOrder || a.id.localeCompare(b.id));
